<template lang="pug">
  article(name="component-fade" mode="out-in")
    navbar(v-bind:header-class="navbarClass")
      span(slot="title") {{ title }}
      span(slot="right")
    .l-content
      .l-static-page
        .c-container
          .l-static-page__body
            ContractView
    .l-copyright
      span {{ overview.company.copyright }}

</template>
<script lang="babel">
  import { mapGetters } from 'vuex'
  import ContractView from '../layouts/Contract.vue'

  export default {
    data () {
      return {
        title: '業務委託について',
        navbarClass: 'c-navbar--primary c-navbar--center',
      }
    },
    created () {
      this.$emit('page-navbar', false)
    },
    title () {
      return this.title
    },
    mounted () {
    },
    components: {
      ContractView
    },
    computed: {
      ...mapGetters('config', {
        overview: 'settings'
      }),
    },
    methods: {
    }

  }
</script>
<style lang="scss">

</style>
